import React from 'react'
import images from '../../../Asset/Img/img';
import "./QualityAssurance.css";
import data from '../../../Data/data';

function QualityAssurance() {
  return (
    <div className='qualityassurance-container'>
      <div className="qualityassurance-content">

        <div className='qualityassurance-header'>
          <h3>KALİTE GÜVENCE (ISO 9001)</h3>
        </div>
        <div className='pro-text-promotion'>
          <div className='iso-container'>
            <h3>HIGH PCK OLARAK 2018 YILINDAN BU YANA ISO 9001 STANDARDINA UYGUN OLARAK HİZMET VERMEKTEYİZ</h3>
            <a href={data.hpcData} target="_blank" download={true} rel="noreferrer"><img src={images.qualityIsoIcon} alt="ISO-icon" title="PDF DOSYASI İNDİR" /></a>
          </div>

          <p>High Performance Compounds Kauçuk A.Ş. Kauçuk hamuru imal ederken;</p>
          <li>Müşterilerimize yüksek kaliteli ve yenilikçi hizmeti sunarak, paydaşlarımız için sürdürülebilir ve karlı bir iş sağlayan</li>
          <li>Müşteri şartnamelerine, uygulanabilir şartlara uygun ürünler sağlayan ve isteklerini karşılayan</li>
          <li>Müşterilere performansı yüksek malzemeler için yenilikçi çözümler sunan</li>
          <li>Müşterinin prosesinde en uygun çözümü sunan</li>
          <li>Müşteri süreçlerinin en uygun seviyeye getirecek desteği sunan hizmet ve malzeme çözümleri sağlayan</li>
          <li>İstenen zamanda teslimat yapan</li>
          <li>Yurtiçi ve yurtdışında rekabet gücü olan ve sürekli değer üretmeye çalışan</li>
          <li>Her proseste sürekli iyileştirmeyi hedefleyen</li>
          <li>Çevreye duyarlı üretim yapan</li>
          <p>bir firma olmayı Kalite Politikası olarak benimsemiştir</p>
        </div>

        <div className='qualityassurance-header-bottom'>

        </div>

      </div>
    </div>
  )
}

export default QualityAssurance
